import { render, staticRenderFns } from "./image-choice.vue?vue&type=template&id=1c81ee1c&scoped=true&"
import script from "./image-choice.vue?vue&type=script&lang=js&"
export * from "./image-choice.vue?vue&type=script&lang=js&"
import style0 from "./image-choice.vue?vue&type=style&index=0&id=1c81ee1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c81ee1c",
  null
  
)

component.options.__file = "image-choice.vue"
export default component.exports